"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dumpTruckTypes = exports.dumpTruckReducer = exports.dumpTruckAction = void 0;
const dump_truck_component_1 = __importDefault(require("./sub-components/dump-truck.component"));
const dump_truck_action_1 = __importDefault(require("./dump-truck.action"));
exports.dumpTruckAction = dump_truck_action_1.default;
const dump_truck_reducer_1 = __importDefault(require("./dump-truck.reducer"));
exports.dumpTruckReducer = dump_truck_reducer_1.default;
const dump_truck_types_1 = require("./dump-truck.types");
Object.defineProperty(exports, "dumpTruckTypes", { enumerable: true, get: function () { return dump_truck_types_1.dumpTruckTypes; } });
exports.default = dump_truck_component_1.default;
